import { useGqlExamTestsQuery } from 'generated/graphql'
import { TOptionsValue } from '@app.feature/careerManage/desktop/careerContent/components/inputFields/select/components/SelectOption'
import { formatToCustomDate } from '../../modules'

type TUseGetExamTestSelectOptionsFnParams = {
  companyId: string
  termId: string
}

const useGetExamTestSelectOptions = ({
  companyId,
  termId,
}: TUseGetExamTestSelectOptionsFnParams): Array<TOptionsValue> => {
  const { data, loading, error } = useGqlExamTestsQuery({
    variables: {
      input: {
        companyId,
        termId,
      },
    },
  })

  if (loading || error || !data?.examTests) {
    return []
  }

  return data?.examTests?.map((test) => ({
    label: formatToCustomDate(test.date),
    value: test.id,
  }))
}

export default useGetExamTestSelectOptions
